import React from "react";
import "./RaceWhere.css"; // Import the CSS file

const RaceWhere = () => {
  return (
    <section className="racewhere-container">
      {/* Left half: image */}
      <div className="racewhere-leftSide">
        <img
          src="./gallery/VLD_8767.jpg"
          alt="Event"
          className="racewhere-image"
          loading="lazy"
        />
      </div>

      {/* Right half: text content */}
      <div className="racewhere-rightSide">
        <h2 className="racewhere-heading">When</h2>
        <p className="racewhere-text">
          November 5 - 8, 2026
          <br />
          08:00 am
        </p>

        <h2 className="racewhere-heading">Where</h2>
        <p className="racewhere-text">Hotel Rtanj at Kopaonik</p>
      </div>
    </section>
  );
};

export default RaceWhere;
